import { SalaryCalculator } from "../components/salary-calculator.component";
import Sidebar from "../components/Sidebar";
import { Header } from "../components/header";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import "../scss/salary-calculator-violet.style.scss";
// Imported only for the .mi-hero class used by the new heading. Every other
// rule in this file is scoped under .manage-invoice-v2 and can't leak here.
import "./../scss/components/manage-invoice.style.scss";

/* Tiny sparkles icon for the hero badge. Inline so the page has no
   new icon-library dependency. */
const HeroSparkles = () => (
    <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .962 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.962 0z" />
        <path d="M20 3v4" /><path d="M22 5h-4" /><path d="M4 17v2" /><path d="M5 18H3" />
    </svg>
);

/* Render the title with the LAST word styled as a violet gradient brand
   accent — works for any locale. Single-word titles are fully styled. */
const renderHeroTitle = (title: string) => {
    const trimmed = (title || '').trim();
    if (!trimmed) return null;
    const idx = trimmed.lastIndexOf(' ');
    if (idx === -1) {
        return <span className="mi-hero__brand">{trimmed}</span>;
    }
    const prefix = trimmed.slice(0, idx);
    const last = trimmed.slice(idx + 1);
    return (
        <>
            {prefix}{' '}
            <span className="mi-hero__brand">{last}</span>
        </>
    );
};

export function InvoiceSalaryCalculatorPage() {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    return (
        <div className="dashboard-page">

            <div className="dashboard-layout">
                <Sidebar
                activeItemId='calculator'
                footer={null}
                onClose={() => setIsSidebarOpen(false)}
                className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                <div className="dashboard-main-content">
                    <Header
                    setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className="violet-salary-page">
                        <div className="vs-orbs" aria-hidden="true">
                            <span className="vs-orb vs-orb--1" />
                            <span className="vs-orb vs-orb--2" />
                        </div>

                        {/* Hero header — same soft violet card used by My Customers,
                            Drafts, My Freelancers, Deductions, Statements, Earnings
                            and the Insurance dashboards. .mi-hero lives at top level
                            in manage-invoice.style.scss so this page just consumes
                            it without needing a .manage-invoice-v2 wrapper. */}
                        <header className="mi-hero">
                            <span className="mi-hero__badge">
                                <HeroSparkles />
                                {t('CALCULATOR_CENTER', { defaultValue: 'Calculator Center' })}
                            </span>
                            <h1 className="mi-hero__title">
                                {renderHeroTitle(t('SALARY_CALCULATOR'))}
                            </h1>
                            <p className="mi-hero__subtitle">
                                {t('SALARY_CALCULATOR_SUBTITLE')}
                            </p>
                        </header>

                        <SalaryCalculator isDashboardPage={false} />
                    </div>
                </div>
            </div>
        </div>
    );
}
